import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import cellTypes from "../../services/cell-types";
import {IChannelModel} from "../models";

import Card from "@toolbox/design/Card";
import Notes from "@toolbox/design/Notes";
import T from "@translate/T";
import {convertNormalizationType} from "../wizard/samples/Row";

interface IChannelsProps {
    intl: IntlShape;
    channels: IChannelModel[];
}

class Channels extends React.PureComponent<IChannelsProps> {
    public render() {
        return (
            <Card headerClassName="bg-secondary" title={<T>Channels</T>}>
                <table className="table table-sm table-striped table-borderless">
                    <thead>
                        <tr>
                            <th>
                                <T>Position</T>
                            </th>
                            <th>
                                <T>Name</T>
                            </th>
                            <th>
                                <T>Cell type</T>
                            </th>
                            <th>
                                <T>Normalization type</T>
                            </th>
                            <th>
                                <T>Notes</T>
                            </th>
                        </tr>
                    </thead>
                    <tbody id="channels-body">{this.renderRows()}</tbody>
                </table>
            </Card>
        );
    }

    private renderRows() {
        const {intl, channels} = this.props;

        return channels.map((channel) => (
            <tr key={channel.position}>
                <td>{channel.position}</td>
                <td>{channel.name}</td>
                <td>{cellTypes.getNamebyId(channel.cellType)}</td>
                <td>
                    {convertNormalizationType(channel.normalizationType).name(
                        intl,
                    )}
                </td>
                <td>
                    <Notes value={channel.notes} suffixId="info" />
                </td>
            </tr>
        ));
    }
}

export default injectIntl(Channels);
